<template>
    <div class="product-list-module" v-if="globals.hideFilter !== '1'">
        <div class="filter-section">
            <div class="title-subsection" v-if="productStore.products.length">
                <h4>{{ $t('filter.title', { group: productStore.products[0].product.title }) }}</h4>
            </div>
            <div class="filters-subsection">
                <div class="filter-selector form-control" v-for="(filter, idx) in  filterStore.filters " :key="idx"
                     :class="{ selected: !!selected[filter.title], 'icon-angle-right-after': !!!selected[filter.title] }">
                    <label class="control-label" for="selectCtrl">{{ filter.title }}</label>
                    <select class="select" :class="checkDsiabled(filter) ? 'disabled' : ''" id="selectCtrl"
                            v-model="selected[filter.title]" :disabled="checkDsiabled(filter)">
                        <option :value="null" selected>{{ filter.title }}</option>
                        <option v-for="( item, itemIndex ) in filterStore[`updatedFilters`][filter.title] " :value="item"
                                :key="itemIndex">
                            {{ item }}
                        </option>
                    </select>
                </div>
                <div class="filter-selector filter-selector--placeholder"></div>
                <div class="filter-selector filter-selector--placeholder"></div>
            </div>
            <div class="bottom-section">
                <button class="change-filter" @click="applyFilters()">
                    <a>{{ $t('filter.apply') }}</a>
                </button>
                <div class="selected-filters">
                    <div class="selected-filter" v-for="( filter, type ) in  appliedFilters " :key="type"
                         @click="removeFilter(filter, type)">
                        <span>{{ filter }}</span>
                        <span class="remove-x">x</span>
                    </div>
                    <span class="sf-label" @click="removeFilters()">{{ $t('filter.reset') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { useFilterStore } from '@/stores/filter'
import { useProductsStore } from '@/stores/products'
import { computed, reactive, watch } from 'vue'
import { useGlobalStore } from '@/stores'

export default {
    name: 'FilterBar',
    setup ()
    {
        const selected = reactive({})
        const filterStore = useFilterStore()
        const productStore = useProductsStore()
        const globals = useGlobalStore()
        const appliedFilters = computed(() =>
        {
            //itereate using filter arr in store make an array with store['applied${filter}'] and return it
            const appliedFilters = {}
            for (const [, value] of Object.entries(filterStore.filters))
            {
                if (filterStore[`appliedFilters`][value.title] && filterStore[`appliedFilters`][value.title] !== null)
                {
                    appliedFilters[value.title] = filterStore[`appliedFilters`][value.title]
                }
            }
            return appliedFilters
        })

        const isFilterSelected = computed(() =>
        {
            return Object.entries(selected).length > 0
        })

        function applyFilters ()
        {
            productStore.currentPage = 1
            productStore.applyFilters()
            for (const [key, value] of Object.entries(selected))
            {
                if (value && value !== null)
                {
                    filterStore[`appliedFilters`][key] = value
                }
                if (value === null)
                {
                    filterStore[`appliedFilters`][key] = ''
                }
            }
        }

        function removeFilters ()
        {
            for (const [key] of Object.entries(selected))
            {
                delete selected[key]
            }
            for (const [, value] of Object.entries(filterStore.filters))
            {
                if (filterStore[`appliedFilters`][value.title] && filterStore[`appliedFilters`][value.title] !== null)
                {
                    appliedFilters[value.title] = ''
                    filterStore[`appliedFilters`][value.title] = ''
                    filterStore[`selectedFilters`][value.title] = ''
                }
            }
            applyFilters()
        }

        function removeFilter (filter, type)
        {
            delete selected[type]
            if (filterStore[`appliedFilters`][type] && filterStore[`appliedFilters`][type] !== null)
            {
                delete appliedFilters[type]
                filterStore[`appliedFilters`][type] = ''
                filterStore[`selectedFilters`][type] = ''
            }
            applyFilters()
        }

        function checkDsiabled (filter)
        {
            return !!filterStore[`appliedFilters`][filter.title]
        }

        watch(selected, (val) =>
        {
            for (const [key, value] of Object.entries(val))
            {
                if (value && value !== null)
                {
                    filterStore[`selectedFilters`][key] = value
                }
                if (value === null)
                {
                    filterStore[`selectedFilters`][key] = ''
                }
            }
        })
        return {
            globals,
            productStore,
            filterStore,
            selected,
            applyFilters,
            removeFilters,
            removeFilter,
            isFilterSelected,
            appliedFilters,
            checkDsiabled
        }
    }

}

</script>
